<template>
  <Modal @click.prevent.stop :modalTitle="$t('user.header.switch_account')" v-if="showSwitchAccountModal"
    :changeModalState="toggleSwitchAccountModal" rounded="42px" :isOpen="showSwitchAccountModal">
    <div class="w-full h-full bg-white p-6 max-h-[80vh] overflow-y-auto">

      <!-- Accounts List -->
      <div class="space-y-4">
        <div v-for="account in accounts" :key="account.id"
          class="flex items-center justify-between p-4 border rounded-lg hover:bg-gray-50">
          <div class="flex items-center gap-3" @click="account.id === currentAccountId ? '' : switchAccount(account.id)"
            style="cursor: pointer">
            <div class="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
              <img v-if="account.photoUrl" :src="account.photoUrl" :alt="account.name"
                class="w-full h-full object-cover rounded-full">
              <span v-else class="text-blue-600 font-semibold">{{ account.name[0].toUpperCase() }}</span>
            </div>
            <div>
              <p class="font-medium">{{ account.name }}</p>
              <p class="text-sm text-gray-500">{{ account.email }}</p>
              <div class="flex items-center gap-1 mt-1">
                <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p class="text-xs text-gray-400">{{ $t('general.last_active') }}: {{ new
                  Date(account.lastActive).toLocaleString() }}</p>
              </div>
            </div>
          </div>

          <div class="flex items-center gap-2">
            <span v-if="account.id === currentAccountId" class="px-2 py-1 text-sm text-green-600 bg-green-100 rounded">
              {{ $t('general.current') }}
            </span>
            <button v-else @click="confirmDeleteAccount(account.userID)"
              class="text-red-500 hover:text-red-600 cursor-pointer" :aria-label="$t('general.delete')">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <!-- Add Account Button -->
      <div class="mt-6">
        <button @click="toggleAddAccountModal"
          class="w-full flex items-center justify-center gap-2 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          {{ $t('user.header.add_new_account') }}
        </button>
      </div>
    </div>
  </Modal>
  <header :class="`
      fixed z-[100] border-b-solid border-b-gray-50 sm:border-b-0 shadow-[0_4px_14px_rgba(0,0,0,0.1)] lg:shadow-none w-screen bg-[#0963FF] h-[55px] top-0 left-0 right-0    flex items-center justify-center  px-auto
      lg:h-[var(--main-header-height)]
    `">
    <nav :class="`
      flex flex-row-reverse justify-between w-full  items-center m-0  px-5 gap-2 flex-wrap
      sm:gap-5
      lg:w-[1200px] lg:h-[44px] lg:gap-2 lg:items-center  lg:flex-row
      xl:w-[1391px] 
      `">
      <!--in-right *logo*-->
      <button aria-label="Home" aria-labelledby="Home" :class="`
        w-[6.5rem] select-none !outline-none flex justify-center items-center self-center cursor-pointer object-cover
        `" :title="$t('general.cezma')" @click="router.replace('/')">
        <img src="@/assets/navBar/logo.svg" :draggable="false" alt="Cezma" width="110" height="33.7" />
      </button>

      <!--in-center *search*  -->
      <MainHeaderSearch :showSearch="showSearch" :closeSearchBar="() => (showSearch = false)" ref="headerSearchRef" />
      <!-- backdrops -->
      <div v-show="showSearch" @click="() => (showSearch = false)"
        class="fixed top-[var(--main-header-height)] inset-0 sm:hidden bg-black/0 lg:bg-transparent z-[1]" />
      <div v-show="showMenu" class="fixed inset-0 lg:hidden bg-black/80 lg:bg-transparent z-[1]" />
      <!-- sidebar -->
      <div id="parent" :class="`
        fixed  transition-[left] select-none z-[3] w-full h-full top-0 ${showMenu ? 'left-0 ltr:left-0' : ' left-[100%] ltr:left-[-100%]'}   flex items-center
          lg:relative lg:z-0 lg:w-fit lg:h-0 lg:top-auto lg:left-0 ltr:lg:left-0 lg:px-0 lg:py-0 lg:bg-[#00000000] min-[1010px]:duration-0
        `" @click="
          (e) => {
            if (e.target.id === 'parent') showMenu = false;
          }
        ">
        <div :class="`
          flex flex-col gap-2 sidebar__container h-full w-[80%] shadow-[4px_0_10px_0_rgba(0,0,0,.4)] lg:shadow-none justify-start bg-[#fffffff9] backdrop-blur-sm lg:backdrop-blur-0 overflow-auto 
          sm:w-[60%] sm:gap-5 lg:flex-row lg:overflow-visible lg:gap-1 lg:h-auto lg:w-fit lg:items-center lg:justify-around lg:bg-transparent
          `">
          <!-- MENU -->
          <div :class="`px-2 sm:px-3 md:px-5 mt-7 lg:mt-0 lg:px-0 lg:py-0 ${currentSidebarViewIndex !== 0 ? 'hidden lg:flex lg:flex-row' : 'flex flex-col lg:flex-row lg:items-center'
            }`">
            <ul ref="sidebarMenu" :class="`
                  flex flex-col gap-1 sm:gap-6 py-5 px-3 lg:px-3.5
                  lg:flex lg:flex-row lg:gap-3 lg:py-0 lg:items-center lg:justify-between
                `">
              <!-- categories button -->
              <li v-if="categories && categories.length > 0" class="lg:hidden">
                <div class="flex justify-between items-center">
                  <button aria-label="browse categories" :class="`
                        flex relative duration-100 w-[90%] !outline-none hover:bg-[#999a9b3f] hover:px-4 py-2 rounded-lg gap-3 box 
                        lg:w-fit lg:py-0  
                        tooltip
                      `" @click="() => changeCurrentSidebarViewIndex(1)" :tooltipTitle="$t('general.categories')"
                    title="Cezma Categories">
                    <svg xmlns="http://www.w3.org/2000/svg" class="aspect-square min-w-[20px]" width="24" height="24"
                      viewBox="0 0 24 24">
                      <g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                        <path d="M0 0h24v24H0z" />
                        <path fill="#4e4e4e"
                          d="M10 3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm10 0h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM10 13H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm7 0a4 4 0 1 1-3.995 4.2L13 17l.005-.2A4 4 0 0 1 17 13z" />
                      </g>
                    </svg>

                    <p class="text-[#4e4e4e]">{{ $t('general.categories') }}</p>
                  </button>
                  <svg class="h-5 w-5 rotate-[270deg] rtl:rotate-[90deg]" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                      clip-rule="evenodd" />
                  </svg>
                </div>

                <hr :class="`lg:hidden mt-2`" />
              </li>
              <template v-for="(page, index) in pageLinks">
                <li v-if="isUserLogged" :key="index"
                  :class="page.name == $t('user.header.cart') ? 'hidden lg:block' : ''">
                  <NuxtLink :to="page.route" :aria-label="`go to ${page.name}`" :class="`
                          flex relative duration-100 w-[90%]  hover:bg-[#999a9b3f] hover:px-4 py-2  rounded-lg gap-3 box 
                          lg:w-fit lg:py-0  
                          tooltip
                        `" @click="
                          () => {
                            if (page.name == $t('user.header.notifications')) handleUnreadNotificationsCount();
                            if (page.name == $t('user.header.chat')) updateUnreadMessages(0);
                            showMenu = false;
                          }
                        " :tooltipTitle="page.name">
                    <img :src="page.icon" :class="`w-[24px] aspect-square min-w-[20px] hidden lg:block`" width="24"
                      height="24" alt="" />
                    <img :src="page.iconGray" :class="`w-[24px] aspect-square min-w-[20px] lg:hidden `" width="24"
                      height="24" alt="" />
                    <div v-if="(page.name == $t('user.header.notifications')) && unreadNotificationsCount"
                      class="absolute flex sm:-top-2 top-1 -right-2">
                      <span
                        class="inline-flex items-center justify-center px-2 py-1 text-[.7rem] font-bold leading-none text-red-100 bg-red-600 rounded-full">
                        {{ unreadNotificationsCount > 99 ? `99+` : unreadNotificationsCount }}
                      </span>
                    </div>
                    <div
                      v-if="(page.name == $t('user.header.cart')) && currentCartCount && (route.fullPath != page.route)"
                      class="absolute flex sm:-top-2 top-1 -right-2">
                      <span
                        class="inline-flex items-center justify-center px-2 py-1 text-[.7rem] font-bold leading-none text-red-100 bg-red-600 rounded-full">
                        {{ +currentCartCount > 99 ? `99+` : currentCartCount }}
                      </span>
                    </div>
                    <div v-if="(page.name == $t('user.header.chat')) && userInfo?.unread_messages"
                      class="absolute flex  items-center justify-center p-1  font-bold leading-none text-red-100 bg-red-600 rounded-full">
                    </div>

                    <p class="lg:hidden text-[#4e4e4e]">{{ page.name }}</p>
                  </NuxtLink>
                  <hr :class="`lg:hidden mt-2`" />
                </li>
              </template>
              <!--              <client-only>-->
              <li v-if="!isUserLogged" id="not-logged">
                <NuxtLink to="/login" @click="showMenu = false" aria-label="go to the login page" :class="`
                        flex relative items-center    duration-100 w-[90%]  hover:bg-[#999a9b3f] hover:px-4 py-2  rounded-lg gap-3 box 
                        lg:w-fit lg:py-1 lg:p-2   lg:gap-1
                      `">
                  <img src="@/assets/navBar/login.svg" :draggable="false"
                    :class="`w-[24px] aspect-square min-w-[20px] hidden lg:block`" width="24" height="24" lazy alt="" />
                  <img src="@/assets/navBar/login-gray.svg" :draggable="false"
                    :class="`w-[24px] aspect-square min-w-[20px] lg:hidden `" width="24" height="24" lazy alt="" />

                  <p class="lg:text-[#ffffff] lg:font-bold lg:text-xs text-[#4e4e4e]">{{ $t('user.header.login') }}</p>
                </NuxtLink>
                <hr :class="`lg:hidden mt-2`" />
              </li>
              <!--              </client-only>-->

              <!-- about profiles -->
              <li v-if="isUserLogged" tabindex="0" @blur="showProfile = false" class="relative">
                <div>
                  <span @click="showProfile = !showProfile" :class="`
                        relative flex duration-100 w-[90%] !outline-none hover:bg-[#999a9b3f]  ${showProfile ? 'px-4 lg:px-0 lg:bg-[#ffffff00]' : 'bg-[#ffffff00]  px-0'
                    }  py-2 rounded-lg gap-3 box  cursor-pointer
                        lg:w-fit lg:py-0  items-end  tooltip
                      `" :aria-label="$t('user.header.settings')" :tooltipTitle="$t('user.header.settings')">
                    <img src="@/assets/navBar/profile.svg" :draggable="false"
                      :class="`w-[24px] aspect-square min-w-[20px] hidden lg:block `" alt="" width="24" height="24" />
                    <img src="@/assets/navBar/profile-gray.svg" :draggable="false"
                      :class="`w-[24px] aspect-square min-w-[20px] lg:hidden `" width="24" height="24" alt="" />
                    <p class="lg:hidden text-[#4e4e4e]">{{ $t('user.header.settings') }}</p>
                    <p
                      :class="`lg:hidden text-[#4e4e4e] justify-self-end duration-100  ${showProfile ? 'rotate-0' : 'rotate-90 ltr:-rotate-90'}`">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-5 w-5">
                        <path fill-rule="evenodd"
                          d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                          clip-rule="evenodd" />
                      </svg>
                    </p>
                  </span>
                  <hr class="lg:hidden" />
                </div>
                <ul id="dropdown" :class="`
                    ${showProfile ? 'max-h-[600px]' : 'max-h-0'
                  }  flex flex-col gap-0 justify-around  transition-[max-height] duration-200 w-full  m-0  list-none overflow-hidden rounded-lg border-none bg-white bg-clip-padding text-left shadow-lg 
                      lg:absolute lg:z-[1000] lg:left-[-50px] lg:top-[35px] lg:w-[200px] px-1
                      max-[335px]:text-[.55rem] text-sm lg:text-[.8rem]
                    `">
                  <!-- profile Settings -->
                  <li :class="`hover:bg-[#999a9b3f] rounded-lg w-full cursor-pointer mt-1 mb-1`"
                    :title="$t('user.header.profile_settings')" @click.stop="
                      () => {
                        showNestedMenu = !showNestedMenu
                      }
                    ">
                    <span :aria-label="$t('user.header.profile')" :aria-labelledby="$t('user.header.profile')" :class="`
                          flex relative  lg:px-6  px-6 py-2  duration-100 w-[90%] hover:translate-x-[-1rem] gap-3 box 
                          lg:w-full  lg:hover:translate-x-[auto] 
                        `">
                      <svg class="text-[#4e4e4e] w-[18px] h-[18px]" xmlns="http://www.w3.org/2000/svg" stroke="#4e4e4e"
                        width="18" height="18" viewBox="0 0 256 256">
                        <path fill="currentColor"
                          d="M234.38 210a123.36 123.36 0 0 0-60.78-53.23a76 76 0 1 0-91.2 0A123.36 123.36 0 0 0 21.62 210a12 12 0 1 0 20.77 12c18.12-31.32 50.12-50 85.61-50s67.49 18.69 85.61 50a12 12 0 0 0 20.77-12M76 96a52 52 0 1 1 52 52a52.06 52.06 0 0 1-52-52" />
                      </svg>

                      <p class="text-[#4e4e4e]">{{ $t('user.header.profile') }}</p>

                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                        class="w-[14px] text-[#4e4e4e] ml-auto font-bold">
                        <path fill-rule="evenodd"
                          d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                          clip-rule="evenodd" />
                      </svg>
                    </span>
                  </li>
                  <!-- profile -->
                  <li
                    :class="`${currentPage == '/profile' ? 'bg-[#0963ff0d]' : ''} ${showNestedMenu ? 'transition-all duration-300 ease-in-out block' : 'hidden'} hover:bg-[#999a9b3f] rounded-lg w-full cursor-pointer mt-1 mb-1`"
                    :title="$t('user.header.profile')" @click.stop="
                      () => {
                        router.push(`${ROUTESNAMES.user.profile}`);
                        showProfile = false;
                        showMenu = false;
                      }
                    ">
                    <span :aria-label="$t('user.header.profile')" :aria-labelledby="$t('user.header.profile')" :class="`
                          flex relative  lg:px-6  px-6 py-2  duration-100 w-[90%] hover:translate-x-[-1rem] gap-3 box 
                          lg:w-full  lg:hover:translate-x-[auto] 
                        `">
                      <svg class="text-[#4e4e4e] w-[18px] h-[18px]" xmlns="http://www.w3.org/2000/svg" stroke="#4e4e4e"
                        width="18" height="18" viewBox="0 0 256 256">
                        <path fill="currentColor"
                          d="M234.38 210a123.36 123.36 0 0 0-60.78-53.23a76 76 0 1 0-91.2 0A123.36 123.36 0 0 0 21.62 210a12 12 0 1 0 20.77 12c18.12-31.32 50.12-50 85.61-50s67.49 18.69 85.61 50a12 12 0 0 0 20.77-12M76 96a52 52 0 1 1 52 52a52.06 52.06 0 0 1-52-52" />
                      </svg>

                      <p class="text-[#4e4e4e]">{{ $t('user.header.profile') }}</p>
                    </span>
                  </li>

                  <li>
                    <hr class="mx-5" />
                  </li>

                  <!-- Switch Account -->
                  <li
                    :class="`${showNestedMenu ? 'transition-all duration-300 ease-in-out block' : 'hidden'} switch-account hover:bg-[#999a9b3f] rounded-lg w-full cursor-pointer mt-1 mb-1`"
                    :title="$t('user.header.switch_account')" @click.stop="
                      () => {
                        toggleSwitchAccountModal();
                        showProfile = false;
                        showMenu = false;
                      }
                    ">
                    <span :aria-label="$t('user.header.switch_account')"
                      :aria-labelledby="$t('user.header.switch_account')" :class="`
                          flex relative  lg:px-6  px-6 py-2  duration-100 w-[90%] hover:translate-x-[-1rem] gap-3 box 
                          lg:w-full  lg:hover:translate-x-[auto] 
                        `">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="#4e4e4e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                      </svg>

                      <p class="text-[#4e4e4e]">{{ $t('user.header.switch_account') }}</p>
                    </span>
                  </li>
                  <li>
                    <hr class="mx-5" />
                  </li>
                  <!-- Logged Devices -->
                  <li
                    :class="`${currentPage == '/security_settings' ? 'bg-[#0963ff0d]' : ''} ${showNestedMenu ? 'transition-all duration-300 ease-in-out block' : 'hidden'} hover:bg-[#999a9b3f] rounded-lg w-full cursor-pointer mt-1 mb-1`"
                    :title="$t('user.header.security_settings')" @click.stop="
                      () => {
                        router.push(`${ROUTESNAMES.user.loggedDevices}`);
                        showProfile = false;
                        showMenu = false;
                      }
                    ">
                    <span :aria-label="$t('user.header.security_settings')"
                      :aria-labelledby="$t('user.header.security_settings')" :class="`
                          flex relative  lg:px-6  px-6 py-2  duration-100 w-[90%] hover:translate-x-[-1rem] gap-3 box 
                          lg:w-full  lg:hover:translate-x-[auto] 
                        `">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="#4e4e4e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                      </svg>

                      <p class="text-[#4e4e4e]">{{ $t('user.header.security_settings') }}</p>
                    </span>
                  </li>

                  <li>
                    <hr class="mx-5" />
                  </li>
                  <!-- Follow up  -->
                  <li
                    :class="`${currentPage == '/follow-up' ? 'bg-[#0963ff0d]' : ''} ${showNestedMenu ? 'transition-all duration-300 ease-in-out block' : 'hidden'} hover:bg-[#999a9b3f] rounded-lg w-full cursor-pointer mt-1 mb-1`"
                    :title="$t('general.follow_up')" @click.stop="
                      () => {
                        router.push(`${ROUTESNAMES.user.follow_up}`);
                        showProfile = false;
                        showMenu = false;
                      }
                    ">
                    <span :aria-label="$t('general.follow_up')" :aria-labelledby="$t('general.follow_up')" :class="`
                          flex relative lg:px-6  px-6 py-2  duration-100 w-[90%] hover:translate-x-[-1rem] gap-3 box 
                          lg:w-full  lg:hover:translate-x-[auto] 
                        `">
                      <!-- <svg class="text-[#4e4e4e] w-[21px] h-[21px]" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 256 256"><path fill="#4e4e4e" d="M196 140a16 16 0 1 1-16-16a16 16 0 0 1 16 16m40-32v80a32 32 0 0 1-32 32H60a32 32 0 0 1-32-32V68.92A32 32 0 0 1 60 36h132a12 12 0 0 1 0 24H60a8 8 0 0 0-8 8.26v.08A8.32 8.32 0 0 0 60.48 76H204a32 32 0 0 1 32 32m-24 0a8 8 0 0 0-8-8H60.48A33.72 33.72 0 0 1 52 98.92V188a8 8 0 0 0 8 8h144a8 8 0 0 0 8-8Z"/></svg> -->
                      <img class="text-[#4e4e4e] w-[21px] h-[21px]" src="../../assets/icons/following.svg" alt="">
                      <p class="text-[#4e4e4e]">{{ $t('general.follow_up') }}</p>
                    </span>
                  </li>
                  <li>
                    <hr class="mx-5" />
                  </li>
                  <!-- ratings  -->
                  <li
                    :class="`${currentPage == '/rating-management' ? 'bg-[#0963ff0d]' : ''} ${showNestedMenu ? 'transition-all duration-300 ease-in-out block' : 'hidden'} hover:bg-[#999a9b3f] rounded-lg w-full cursor-pointer mt-1 mb-1`"
                    :title="$t('general.rating_management')" @click.stop="
                      () => {
                        router.push(`${ROUTESNAMES.user.rating_management}`);
                        showProfile = false;
                        showMenu = false;
                      }
                    ">
                    <span :aria-label="$t('general.rating_management')"
                      :aria-labelledby="$t('general.rating_management')" :class="`
                          flex relative lg:px-6  px-6 py-2  duration-100 w-[90%] hover:translate-x-[-1rem] gap-3 box 
                          lg:w-full  lg:hover:translate-x-[auto] 
                        `">
                      <!-- <svg class="text-[#4e4e4e] w-[21px] h-[21px]" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 256 256"><path fill="#4e4e4e" d="M196 140a16 16 0 1 1-16-16a16 16 0 0 1 16 16m40-32v80a32 32 0 0 1-32 32H60a32 32 0 0 1-32-32V68.92A32 32 0 0 1 60 36h132a12 12 0 0 1 0 24H60a8 8 0 0 0-8 8.26v.08A8.32 8.32 0 0 0 60.48 76H204a32 32 0 0 1 32 32m-24 0a8 8 0 0 0-8-8H60.48A33.72 33.72 0 0 1 52 98.92V188a8 8 0 0 0 8 8h144a8 8 0 0 0 8-8Z"/></svg> -->
                      <img class="text-[#4e4e4e] w-[21px] h-[21px]" src="../../assets/icons/evaluate.svg" alt="">
                      <p class="text-[#4e4e4e]">{{ $t('general.rating_management') }}</p>
                    </span>
                  </li>
                  <!-- My Addresses -->
                  <li
                    :class="`${currentPage == '/addresses' ? 'bg-[#0963ff0d]' : ''} ${showNestedMenu ? 'transition-all duration-300 ease-in-out block' : 'hidden'} hover:bg-[#999a9b3f] rounded-lg w-full cursor-pointer mt-1 mb-1`"
                    :title="$t('general.addresses.my_addresses')" @click.stop="
                      () => {
                        router.push(`${ROUTESNAMES.user.addresses}`);
                        showProfile = false;
                        showMenu = false;
                      }
                    ">
                    <span :aria-label="$t('general.addresses.my_addresses')"
                      :aria-labelledby="$t('general.addresses.my_addresses')" :class="`
                          flex relative  lg:px-6  px-6 py-2  duration-100 w-[90%] hover:translate-x-[-1rem] gap-3 box 
                          lg:w-full  lg:hover:translate-x-[auto] 
                        `">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="#4e4e4e" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                      </svg>
                      <p class="text-[#4e4e4e]">{{ $t('general.addresses.my_addresses') }}</p>
                    </span>
                  </li>
                  <li v-if="showNestedMenu">

                    <hr class="mx-5 font-bold" />
                    <hr class="mx-5 font-bold" />
                    <hr class="mx-5 font-bold" />
                    <hr class="mx-5 font-bold" />
                    <hr class="mx-5 font-bold" />
                    <hr class="mx-5 font-bold" />
                  </li>
                  <!-- My stores -->
                  <li
                    :class="`${currentPage == '/my-stores' ? 'bg-[#0963ff0d]' : ''} hover:bg-[#999a9b3f] rounded-lg w-full cursor-pointer mt-1 mb-1`"
                    v-if="isReseller" :title="$t('user.store.my_stores')" @click.stop="
                      () => {
                        router.push(`${ROUTESNAMES.user.myStores}`);
                        showProfile = false;
                        showMenu = false;
                      }
                    ">
                    <span :aria-label="$t('user.store.my_stores')" :aria-labelledby="$t('user.store.my_stores')" :class="`
                          flex relative  lg:px-6  px-6 py-2  duration-100 w-[90%] hover:translate-x-[-1rem] gap-3 box 
                          lg:w-full  lg:hover:translate-x-[auto] 
                        `">
                      <IconMyStores :color="`#4e4e4e`" :height="18" :width="18" />

                      <p class="text-[#4e4e4e]">{{ $t('user.store.my_stores') }}</p>
                    </span>
                  </li>
                  <li v-if="isReseller">
                    <hr class="mx-5" />
                  </li>
                  <!-- my orders -->
                  <li
                    :class="`${currentPage == '/orders' ? 'bg-[#0963ff0d]' : ''} hover:bg-[#999a9b3f] rounded-lg w-full cursor-pointer mt-1 mb-1`"
                    :title="$t('user.header.my_orders')" @click.stop="
                      () => {
                        router.push(`${ROUTESNAMES.user.orders}`);
                        showProfile = false;
                        showMenu = false;
                      }
                    ">
                    <span :aria-label="$t('user.header.my_orders')" :aria-labelledby="$t('user.header.my_orders')"
                      :class="`
                          flex relative  lg:px-6  px-6 py-2  duration-100 w-[90%] hover:translate-x-[-1rem] gap-3 box 
                          lg:w-full lg:hover:translate-x-[auto] 
                        `">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                        <g fill="none">
                          <path
                            d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                          <path fill="#4e4e4e"
                            d="M20 3a2 2 0 0 1 1.995 1.85L22 5v4h-1v10a2 2 0 0 1-1.85 1.995L19 21H5a2 2 0 0 1-1.995-1.85L3 19V9H2V5a2 2 0 0 1 1.85-1.995L4 3zm-1 6H5v10h14zm-5 4a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2zm6-8H4v2h16z" />
                        </g>
                      </svg>

                      <p class="text-[#4e4e4e]">{{ $t('user.header.my_orders') }}</p>
                    </span>
                  </li>
                  <hr class="mx-5" />
                  <!-- My wallet -->
                  <li
                    :class="`${currentPage == '/wallet' ? 'bg-[#0963ff0d]' : ''} hover:bg-[#999a9b3f] rounded-lg w-full cursor-pointer mt-1 mb-1`"
                    :title="$t('general.wallet')" @click.stop="
                      () => {
                        router.push(`${ROUTESNAMES.user.myWallet}`);
                        showProfile = false;
                        showMenu = false;
                      }
                    ">
                    <span :aria-label="$t('general.wallet')" :aria-labelledby="$t('general.wallet')" :class="`
                          flex relative lg:px-6  px-6 py-2  duration-100 w-[90%] hover:translate-x-[-1rem] gap-3 box 
                          lg:w-full  lg:hover:translate-x-[auto] 
                        `">
                      <svg class="text-[#4e4e4e] w-[21px] h-[21px]" xmlns="http://www.w3.org/2000/svg" width="21"
                        height="21" viewBox="0 0 256 256">
                        <path fill="#4e4e4e"
                          d="M196 140a16 16 0 1 1-16-16a16 16 0 0 1 16 16m40-32v80a32 32 0 0 1-32 32H60a32 32 0 0 1-32-32V68.92A32 32 0 0 1 60 36h132a12 12 0 0 1 0 24H60a8 8 0 0 0-8 8.26v.08A8.32 8.32 0 0 0 60.48 76H204a32 32 0 0 1 32 32m-24 0a8 8 0 0 0-8-8H60.48A33.72 33.72 0 0 1 52 98.92V188a8 8 0 0 0 8 8h144a8 8 0 0 0 8-8Z" />
                      </svg>

                      <p class="text-[#4e4e4e]">{{ $t('general.wallet') }}</p>
                    </span>
                  </li>
                  <li>
                    <hr class="mx-5" />
                  </li>
                  <!-- logout -->
                  <li class="w-full cursor-pointer mt-1 mb-1 hover:bg-[#999a9b3f] rounded-lg"
                    :title="$t('user.header.logout')" @click.stop="
                      () => {
                        openDialog('confirmation')
                        showProfile = false;
                        showMenu = false;
                      }
                    ">
                    <span :aria-label="$t('user.header.logout')" :aria-labelledby="$t('user.header.logout')" :class="`
                          flex relative  lg:px-6  px-6 py-2  duration-100 w-[90%] hover:translate-x-[-1rem]  gap-3 box 
                          lg:w-full  lg:hover:translate-x-[auto]
                        `">
                      <img src="@/assets/navBar/logout-gray.svg"
                        :class="`lg:w-[15px] w-[20px] aspect-square min-w-[20px] `" width="20" height="20" alt="" />

                      <p class="text-[#4e4e4e]">{{ $t('user.header.logout') }}</p>
                    </span>
                  </li>
                </ul>
              </li>
              <li class="relative" tabindex="0" @blur="showSettings = false">
                <div>
                  <span @click="showSettings = !showSettings" role="button"
                    :class="` relative flex duration-100 w-[90%] !outline-none hover:bg-[#999a9b3f]  ${showSettings ? 'px-4 lg:px-0 lg:bg-[#ffffff00]' : 'bg-[#ffffff00]  px-0'}  py-2  rounded-lg gap-3 box  cursor-pointer lg:w-fit lg:py-0  items-end  tooltip `"
                    :tooltipTitle="$t('user.header.website_settings')" :aria-label="$t('user.header.website_settings')">
                    <img :src="websiteSettingsIcon" :draggable="false"
                      :class="`w-[24px] aspect-square min-w-[20px] hidden lg:block `" alt="" width="24" height="24" />
                    <img :src="websiteSettingsIconGray" :draggable="false"
                      :class="`w-[24px] aspect-square min-w-[20px] lg:hidden `" width="24" height="24" alt="" />
                    <p class="lg:hidden text-[#4e4e4e]">{{ $t('user.header.website_settings') }}</p>
                    <p
                      :class="`lg:hidden text-[#4e4e4e] justify-self-end duration-100  ${showSettings ? 'rotate-0 ' : 'rotate-90 ltr:-rotate-90'}`">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-5 w-5">
                        <path fill-rule="evenodd"
                          d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                          clip-rule="evenodd" />
                      </svg>
                    </p>
                  </span>
                  <hr class="lg:hidden" />
                </div>
                <ul id="dropdown" :class="` ${showSettings ? 'max-h-[400px]' : 'max-h-0'} transition-[max-height] duration-200 flex flex-col gap-0 justify-around   w-full  m-0  list-none overflow-hidden rounded-lg border-none bg-white bg-clip-padding text-left shadow-lg 
                      lg:absolute lg:z-[1000] lg:left-[-50px] lg:top-[35px] lg:w-[200px] px-1
                      max-[335px]:text-[.55rem] text-sm lg:text-[.8rem] `">
                  <!-- store verification -->
                  <li v-if="isReseller"
                    :class="`${currentPage === ROUTESNAMES.user.verifyStore ? 'bg-[#0963ff0d]' : ''} rounded-lg w-full cursor-pointer mt-1 mb-1`"
                    :title="$t('user.header.manage_verification')" @click.stop="
                      () => {
                        router.push(`${ROUTESNAMES.user.verifyStore}`);
                        showSettings = false;
                        showMenu = false;
                      }
                    ">
                    <span :aria-label="$t('user.header.manage_verification')"
                      :aria-labelledby="$t('user.header.manage_verification')" :class="`
                          flex relative  lg:px-6  px-6 py-2  duration-100 w-[90%]  hover:bg-[#999a9b3f]  hover:translate-x-[-1rem]  rounded-lg gap-3 box 
                          lg:w-full  lg:hover:translate-x-[auto] 
                        `">
                      <img :src="verifyIcon" :class="`lg:w-[15px] w-[20px] aspect-square  `" width="20" height="20"
                        alt="" />

                      <p class="text-[#4e4e4e]">{{ $t('user.header.manage_verification') }}</p>
                    </span>

                    <hr class="mx-5" />

                  </li>
                  <!-- win with cezma -->
                  <li
                    :class="`${currentPage === ROUTESNAMES.user.win_with_cezma ? 'bg-[#0963ff0d]' : ''} rounded-lg w-full cursor-pointer mt-1 mb-1`"
                    :title="$t('general.win_with_cezma')" @click.stop="
                      () => {
                        router.push(`${ROUTESNAMES.user.win_with_cezma}`);
                        showSettings = false;
                        showMenu = false;
                      }
                    ">
                    <span :aria-label="$t('general.win_with_cezma')" :aria-labelledby="$t('general.win_with_cezma')"
                      :class="`
                          flex relative  lg:px-6  px-6 py-2  duration-100 w-[90%]  hover:bg-[#999a9b3f]  hover:translate-x-[-1rem]  rounded-lg gap-3 box 
                          lg:w-full  lg:hover:translate-x-[auto] 
                        `">
                      <img :src="WinWithCezma" :class="`lg:w-[15px] w-[20px] aspect-square  `" width="20" height="20"
                        alt="" />

                      <p class="text-[#4e4e4e]">{{ $t('general.win_with_cezma') }}</p>
                    </span>

                    <hr class="mx-5" />

                  </li>

                  <!-- activity log -->
                  <li
                    :class="`${currentPage === ROUTESNAMES.user.activity_log ? 'bg-[#0963ff0d]' : ''} rounded-lg w-full cursor-pointer mt-1 mb-1`"
                    :title="$t('general.activity_log')" @click.stop="
                      () => {
                        router.push(`${ROUTESNAMES.user.activity_log}`);
                        showSettings = false;
                        showMenu = false;
                      }
                    ">
                    <span :aria-label="$t('general.activity_log')" :aria-labelledby="$t('general.activity_log')" :class="`
                          flex relative  lg:px-6  px-6 py-2  duration-100 w-[90%]  hover:bg-[#999a9b3f]  hover:translate-x-[-1rem]  rounded-lg gap-3 box 
                          lg:w-full  lg:hover:translate-x-[auto] 
                        `">
                      <img :src="ActivityLog" :class="`lg:w-[15px] w-[20px] aspect-square  `" width="20" height="20"
                        alt="" />

                      <p class="text-[#4e4e4e]">{{ $t('general.activity_log') }}</p>
                    </span>

                    <hr class="mx-5" />

                  </li>
                  <!-- language -->
                  <li class="w-full cursor-pointer mt-1 mb-1" :title="$t('user.header.language')" @click.stop="
                    () => {
                      openDialog('language');
                      showSettings = false;
                      showMenu = false;
                    }
                  ">
                    <span :aria-label="$t('user.header.language')" :aria-labelledby="$t('user.header.language')" :class="`
                          flex relative  lg:px-6  px-6 py-2  duration-100 w-[90%]  hover:bg-[#999a9b3f]  hover:translate-x-[-1rem]  rounded-lg gap-3 box 
                          lg:w-full  lg:hover:translate-x-[auto] 
                        `">
                      <img :src="languageIcon" :class="`lg:w-[15px] w-[20px] aspect-square  `" width="20" height="20"
                        alt="" />

                      <p class="text-[#4e4e4e]">{{ $t('user.header.language') }}</p>
                    </span>
                  </li>
                </ul>
              </li>
            </ul>
            <!-- buttons -->
            <ul :class="`
                  flex flex-col gap-3 
                  lg:flex-row lg:items-center lg:gap-3.5 lg:ms-10
                  md:ms-0
                `">

              <!-- upgrade reseller -->
              <li v-if="!isGuest && notModeratorReseller" :class="`
                ${currentPage == '/upgrade' ? 'brightness-125' : 'hover:brightness-110'} 
                w-[90%] text-[0.8rem] font-bold  duration-150 transition-all bg-[#272727] text-white text-center cursor-pointer  rounded-[5px] py-2.5 px-1 active:scale-[.7] 
                lg:w-[8.3125rem] lg:text-[.7rem]
                `" @click="
                  () => {
                    isUserLogged ? router.push(ROUTESNAMES.user.upgrade) : router.push(ROUTESNAMES.user.login);
                    showMenu = false;
                  }
                ">
                <button :aria-label="$t('user.header.add_store')" :aria-labelledby="$t('user.header.add_store')">
                  {{ $t('user.header.add_store') }}
                </button>
              </li>
              <!--  reseller to control panel-->
              <!-- @focusin="showControlPanelDropdown = true"
              @focusout="showControlPanelDropdown = false" -->
              <li v-if="isReseller" tabindex="0" @blur="showControlPanelDropdown = false" :class="`relative  w-[90%]  text-[0.8rem] bg-[#2f51f65b] rounded-[5px] text-center lg:m-auto cursor-pointer duration-150  
                  lg:w-fit lg:text-[0.9rem] p-0`">
                <span @click="showControlPanelDropdown = !showControlPanelDropdown"
                  :aria-label="$t('user.header.control_panel')" class="w-full text-[0.8rem] font-bold hover:brightness-105 duration-150 transition-all bg-[#FFCC00] text-center rounded-[5px] cursor-pointer py-2.5 lg:py-2 px-1 flex justify-center items-center gap-1 active:scale-[.7]
                  lg:w-[8.3125rem] lg:text-[.7rem] lg:justify-around">
                  <p>{{ $t('user.header.control_panel') }}</p>
                  <img src="@/assets/navBar/dasboard.svg" alt="" class="w-[19px] h-[19px] object-contain" />
                  <svg
                    :class="`justify-self-end ${showControlPanelDropdown ? 'rotate-180' : ''} transition-transform duration-150`"
                    xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 12 12">
                    <path fill="currentColor"
                      d="M3.076 7.383A1 1 0 0 0 4 8h4a1 1 0 0 0 .707-1.707l-2-2a1 1 0 0 0-1.414 0l-2 2a1 1 0 0 0-.217 1.09" />
                  </svg>
                </span>
                <ul id="dropdown" :class="`${showControlPanelDropdown ? 'max-h-[400px]' : 'max-h-0'
                  } transition-[max-height] duration-200 flex flex-col gap-0 justify-around w-full m-0 list-none overflow-hidden rounded-lg border-none bg-white bg-clip-padding text-left shadow-lg 
                      lg:absolute lg:z-[1000] lg:left-[50%] lg:translate-x-[-50%] lg:top-[35px] lg:w-[150px] px-1
                      max-[335px]:text-[.55rem] text-sm lg:text-[.8rem] 
                    `">
                  <!-- control panel -->
                  <!-- to panel's dashboard page -->
                  <li class="w-full cursor-pointer"
                    @click.stop="() => handelControlPanel({ redirectToPanelPage: 'homepage' })">
                    <span :aria-label="$t('user.header.control_panel')"
                      :aria-labelledby="$t('user.header.control_panel')" :class="`
                          flex relative lg:px-6 px-6 py-2 duration-100 w-full hover:bg-[#999a9b3f] rounded-lg gap-3 box 
                            lg:hover:translate-x-[auto] `">
                      <p class="text-[#4e4e4e]">{{ $t('user.header.control_panel') }}</p>
                    </span>
                  </li>
                  <li>
                    <hr class="mx-5" />
                  </li>
                  <!-- to panel's products page -->
                  <li class="w-full cursor-pointer"
                    v-if="(hasPermissionsExceptGet('products') && isModeratorReseller) || isResellerOnly"
                    @click.stop="() => handelControlPanel({ redirectToPanelPage: 'products' })">
                    <span :aria-label="$t('user.header.my_products')" :aria-labelledby="$t('user.header.my_products')"
                      :class="`flex relative lg:px-6  px-6 py-2  duration-100 w-full hover:bg-[#999a9b3f] rounded-lg gap-3 box 
                            lg:hover:translate-x-[auto]`">
                      <p class="text-[#4e4e4e]"> {{ $t('user.header.my_products') }}</p>
                    </span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <!-- CATEGORIES - Todo: move this into a separate component -->
          <div class="block lg:hidden">
            <!-- MAIN-CATEGORIES -->
            <div v-if="currentSidebarViewIndex == 1">
              <!-- slider header -->
              <div class="sticky top-0 py-4 px-3 z-[1] bg-[#fdfdfd] shadow-gray-200 backdrop-blur-sm">
                <h2
                  class="text-center mx-auto text-ellipsis overflow-hidden whitespace-nowrap font-[700] text-[19px] sm:text-[20px]">
                  {{ $t('user.browse_categories') }}
                </h2>
                <button @click="() => changeCurrentSidebarViewIndex(currentSidebarViewIndex - 1)" aria-label="Go back"
                  class="ml-auto absolute p-1 top-[50%] translate-y-[-50%]">
                  <span>
                    <svg class="ltr:rotate-180" xmlns="http://www.w3.org/2000/svg" width="35" height="35"
                      viewBox="0 0 24 24">
                      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1.5" d="m10 17l5-5l-5-5" />
                    </svg>
                    <span class="sr-only">Go back</span>
                  </span>
                </button>
              </div>
              <!-- list -->
              <ul class="list-none px-5 md:px-7 pt-2 pb-5" v-if="categories && categories.length > 0">
                <SidebarMainCategoryItem v-for="category in categories" :key="category.id" :category="category"
                  :onMainCategoryItemClick="onMainCategoryItemClick" :getCurrentQueryObj="getCurrentQueryObj" />
              </ul>
              <div v-else>{{ $t('general.empty_list') }}</div>
            </div>
            <!-- SUB-CATEGORIES -->
            <div v-else-if="currentSidebarViewIndex == 2">
              <div v-if="activeCategoryItem">
                <!-- slider header -->
                <div class="sticky top-0 py-4 px-3 z-[1] bg-[#fdfdfd] shadow-gray-200 backdrop-blur-sm">
                  <h6
                    class="text-center mx-auto text-ellipsis overflow-hidden whitespace-nowrap font-[700] text-[19px] sm:text-[20px]">
                    {{ activeCategoryItem[finalizedNameKey] }}
                  </h6>
                  <button @click="() => changeCurrentSidebarViewIndex(currentSidebarViewIndex - 1)" aria-label="Go back"
                    class="ml-auto absolute p-1 top-[50%] translate-y-[-50%]">
                    <span>
                      <svg class="ltr:rotate-180" xmlns="http://www.w3.org/2000/svg" width="35" height="35"
                        viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.5" d="m10 17l5-5l-5-5" />
                      </svg>
                      <span class="sr-only">Go back</span>
                    </span>
                  </button>
                </div>
                <!-- list -->
                <ul class="list-none px-5 md:px-7 pt-2 pb-5"
                  v-if="activeCategoryItem.children && activeCategoryItem.children.length > 0">
                  <SidebarSubCategoryItem v-for="subCategory in activeCategoryItem.children" :key="subCategory.id"
                    :subCategory="subCategory" :onSubCategoryItemClick="onSubCategoryItemClick"
                    :mainCategoryId="activeCategoryItem && activeCategoryItem.id"
                    :getCurrentQueryObj="getCurrentQueryObj" />
                </ul>
                <div v-else>{{ $t('general.empty_list') }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- close indicator button -->
        <div
          class="absolute lg:hidden rtl:left-[5vw] rtl:right-auto rtl:sm:left-[32%] right-[10%] left-auto sm:right-[32%] top-[25px]">
          <button @click="() => (showMenu = false)" aria-label="Close sidebar" tabindex="0" type="button"
            class="p-1 sm:p-2">
            <svg class="w-[24px] h-[24px] sm:w-[26px] sm:h-[26px]" xmlns="http://www.w3.org/2000/svg" width="24"
              height="24" viewBox="0 0 48 48">
              <g fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
                <path d="M8 8L40 40" />
                <path d="M8 40L40 8" />
              </g>
            </svg>
            <span class="sr-only">Close sidebar</span>
          </button>
        </div>
      </div>

      <!-- burger menu, cart, and search icons - shows on mobile only -->
      <div :class="`flex flex-row-reverse lg:hidden justify-start items-center w-fit bg-[#37695000]`">
        <!-- cart icon -- appear from 0 to lg -->
        <NuxtLink v-if="isUserLogged" :to="ROUTESNAMES.user.cart" :aria-label="`go to cart`" :class="`
            relative block w-[35px] cursor-pointer
            !bg-transparent
            !py-0
            !px-1.5
          `" @click="() => showSearch = false">
          <img :src="cartIcon" :class="`w-[1.375rem] h-[1.375rem] xs:w-[1.489rem] xs:h-[1.489rem] aspect-square block`"
            width="23" height="23" alt="" />
          <div v-if="currentCartCount" class="absolute flex sm:-top-[0.4rem] -top-[0.5rem] -right-2">
            <span
              class="inline-flex items-center justify-center px-1.5 py-[0.2rem] text-[.7rem] font-bold leading-none text-red-100 bg-red-600 rounded-full">
              {{ +currentCartCount > 99 ? `99+` : currentCartCount }}
            </span>
          </div>
        </NuxtLink>
        <!-- search icon -- appear from 0 to sm -->
        <ClientOnly>
          <button @click="onMagnifierClick" class="px-1 xxs:px-1.5" aria-label="Search products and stores"
            aria-labelledby="Search products and stores">
            <img :src="showSearch ? searchClosedIcon : searchOpenedIcon"
              class="sm:hidden block object-contain w-[1.385rem] h-[1.385rem] xs:w-[1.489rem] xs:h-[1.489rem] cursor-pointer"
              alt="" />
          </button>
        </ClientOnly>

        <!-- burger menu-- appear from 0 to lg -->
        <button @click="toggleSidebar" class="px-1 xxs:pl-1.5 xxs:pr-0 xxs:ltr:pl-0 xxs:ltr:pr-1.5"
          :aria-label="`${showMenu ? 'close' : 'show'} site menu`"
          :aria-labelledby="`${showMenu ? 'close' : 'show'} site menu`">
          <img :src="showMenu ? menuClosedIcon : menuOpenedIcon"
            class="block w-[1.385rem] h-[1.385rem] xs:w-[1.50rem] xs:h-[1.50rem] cursor-pointer" alt="" width="23"
            height="23" />
        </button>
      </div>
    </nav>
    <!-- dialog -->
    <div id="customConfirmationDialog" v-if="dialog.isOpen">
      <div @click="closeDialog" :class="`modal-backdrop ${dialog.isOpen ? '' : 'hidden'}`"></div>
      <div id="popupModal" tabindex="-1">
        <div class="fixed modal-inner z-[150] w-[95.5%] max-w-xl max-h-full">
          <div class="relative bg-white rounded-lg modal_inner_dialog">
            <button @click="closeDialog" type="button" ref="closeLoggingoutConfirmationBtn"
              class="absolute top-3 left-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 mr-auto inline-flex items-center">
              <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd" />
              </svg>
              <span class="sr-only">Close modal</span>
            </button>
            <!-- dialog content -->
            <div v-if="dialog.type === 'confirmation'" class="p-6 text-center">
              <svg aria-hidden="true" class="mx-auto mb-4 text-gray-400 w-14 h-14" fill="none" stroke="currentColor"
                viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h3 class="mb-5 text-lg font-normal text-gray-500">{{ $t('general.logout_question') }}</h3>
              <div class="flex justify-center items-center gap-2">
                <button :tabindex="0" :aria-label="$t('general.yes')" @click="handleLogout" type="button"
                  :class="` text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2`">
                  {{ $t('general.yes') }}
                </button>
                <button :aria-label="$t('general.no')" @click="closeDialog" type="button"
                  :class="`text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10`">
                  {{ $t('general.no') }}
                </button>
              </div>
            </div>
            <div v-if="dialog.type === 'language'" class="mx-auto  py-6 px-20 md:w-[80%]  text-center">
              <h3 class="text-md font-semibold mt-3 text-black">{{ $t('user.header.change_language') }}</h3>
              <div class="flex flex-col gap-2 mt-8">
                <button @click="lang = 'ar'" aria-label="العربية" :tabindex="0"
                  class="flex justify-between items-center hover:bg-slate-200 py-2 px-2 border-[1px] border-[#D8D8D8] rounded-md ">
                  <!-- <p class="">{{ $t('user.header.arabic') }}</p> -->
                  <p class="">العربية</p>
                  <img :class="`${lang == 'ar' ? 'opacity-100' : 'opacity-0'} w-5 h-5 duration-200 `" :src="rightMark"
                    alt="">
                </button>
                <button @click="lang = 'en'" aria-label="English"
                  class="flex justify-between items-center hover:bg-slate-200 py-2 px-2 border-[1px] border-[#D8D8D rounded-md ">
                  <p class="">English</p>
                  <!-- <p class="">{{ $t('user.header.english') }}</p> -->
                  <img :class="`${lang == 'en' ? 'opacity-100' : 'opacity-0'} w-5 h-5 duration-200 `" :src="rightMark"
                    alt="">
                </button>
              </div>
              <div class="flex justify-center items-center gap-2 mt-8">
                <button @click="() => handleChangeLanguage(lang)" type="button"
                  :class="` text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm inline-flex items-center px-9 py-2.5 text-center mr-2`">
                  {{ $t('general.confirm') }}
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </header>
  <Modal @click.prevent.stop :modalTitle="$t('user.header.add_new_account')" v-if="showAddAccountModal"
    :changeModalState="toggleAddAccountModal" rounded="42px" :isOpen="showAddAccountModal">
    <div
      class="max-w-[790px] max-h-fit lg:w-[52vw] w-[90vw] mx-auto p-5 relative lg:rounded-[42px] rounded-[20px] bg-[#FFFFFF]">
      <form class="flex lg:flex-row-reverse flex-col justify-around">
        <!-- Image section -->
        <div
          class="border-2 lg:w-[50%] w-[75%] max-w-[390px] hidden lg:flex m-auto md:px-10 lg:px-9 border-[#c5181800]">
          <img src="@/assets/auth/login/welcome.jpg" draggable="false" class="select-none" alt="" />
        </div>

        <!-- Form section -->
        <div
          class="border-2 lg:w-[50%] flex flex-col justify-center h-[auto] lg:py-20 xl:pr-20 ltr:xl:pl-20 ltr:xl:pr-0 sm:px-10 lg:px-0 lg:block w-[100%] border-[#11090000]">
          <!-- Title -->
          <h1 class="normal-nums font-bold sm:text-[3rem] text-[2rem]">{{ $t('user.auth.welcome') }}</h1>
          <p class="normal-nums sm:text-[1rem] text-[.75rem] text-[#858585]">{{ $t('user.auth.Login_to_continue') }}</p>

          <!-- Email/Phone Input -->
          <div class="relative mt-8">
            <div
              class="absolute inset-y-0 right-0 ltr:left-0 pr-3.5 ltr:pr-0 ltr:pl-3.5 flex items-center pointer-events-none font-[950]">
              <img src="@/assets/auth/login/profile.svg" alt="" />
            </div>
            <input v-model="formData.phone_or_email" type="text"
              class="bg-[#FFFFFF] outline-none border border-[#E6E6E6] text-gray-900 rounded-[5px] focus:border-blue-500 sm:text-[.8rem] text-[0.9rem] block w-full pr-10 ltr:pr-0 ltr:pl-10 p-2.5"
              :placeholder="`${$t('general.email')} ${$t('general.or')} ${$t('general.phone')}`" />
          </div>

          <!-- Password Input -->
          <div class="relative mt-2">
            <div
              class="absolute inset-y-0 right-0 ltr:left-0 pr-3.5 ltr:pr-0 ltr:pl-3.5 flex items-center pointer-events-none">
              <img src="@/assets/auth/login/lock.svg" alt="" />
            </div>
            <input v-model="formData.password" :type="showAddAccountPass ? 'text' : 'password'"
              class="bg-[#FFFFFF] outline-none border border-[#E6E6E6] text-gray-900 rounded-[5px] focus:border-blue-500 sm:text-[.8rem] text-[0.9rem] block w-full px-10 p-2.5"
              :placeholder="$t('user.auth.password')" />
            <div @click="showAddAccountPass = !showAddAccountPass"
              class="absolute inset-y-0 left-0 ltr:left-auto ltr:right-0 pl-3.5 ltr:pl-0 ltr:pr-3.5 flex items-center cursor-pointer">
              <img :src="showAddAccountPass ? hidePasswordIcon : showPasswordIcon"
                :title="showAddAccountPass ? 'hide' : 'show'" alt="" />
            </div>
          </div>

          <!-- Submit Button -->
          <button type="submit" @click="submitForm" :disabled="isAddAccountProcessing"
            :class="`text-white w-full ${isAddAccountProcessing ? 'bg-[#053486]' : 'bg-[#0963FF]'} hover:bg-blue-800 font-medium rounded-md text-lg mt-5 px-10 py-2 mb-2 focus:outline-none`">
            {{ isAddAccountProcessing ? $t('general.loading') : $t('user.auth.login') }}
          </button>
        </div>
      </form>
    </div>
  </Modal>
  <!-- Add this new confirmation modal -->
  <div id="deleteAccountConfirmationDialog" v-if="deleteAccountDialog.isOpen">
    <div class="fixed inset-0 bg-black bg-opacity-50 z-[300] flex items-center justify-center p-4">
      <div class="relative bg-white rounded-lg shadow-xl max-w-md w-full">
        <!-- Close button -->
        <button @click="closeDeleteAccountDialog" type="button"
          class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
          <span class="sr-only">Close modal</span>
        </button>

        <!-- Dialog content -->
        <div class="p-6 text-center">
          <svg aria-hidden="true" class="mx-auto mb-4 text-gray-400 w-14 h-14" fill="none" stroke="currentColor"
            viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>

          <h3 class="mb-5 text-lg font-normal text-gray-800">{{ $t('general.delete_account_confirmation') }}</h3>
          <p class="mb-5 text-sm text-gray-500">{{ $t('general.delete_account_description') }}</p>

          <div class="flex justify-center items-center gap-2">
            <button @click="proceedWithAccountDeletion" type="button"
              class="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2">
              {{ $t('general.delete') }}
            </button>
            <button @click="closeDeleteAccountDialog" type="button"
              class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10">
              {{ $t('general.cancel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeaderSearch from './MainHeaderSearch.vue';
import IconApp from '@/assets/shared/icons/app.svg';

import IconMyStores from '@/assets/shared/icons/IconMyStores.vue';
import { useGlobalStore } from '@/store/Modules/global';
import { getFirebaseToken, firebaseMessage, parseQueryString, ROUTESNAMES, MAINROLES, SPECIFICROLES, APIREQUESTS, useLocalStorage } from '@/helpers';
import SidebarMainCategoryItem from '@/components/user/SidebarCategories/MainCategoryItem.vue';
import SidebarSubCategoryItem from '@/components/user/SidebarCategories/SubCategoryItem.vue';
import menuClosedIcon from '@/assets/navBar/burger-menu-close.svg';
import menuOpenedIcon from '@/assets/navBar/burger-menu.svg';
import searchClosedIcon from '@/assets/navBar/search-close.svg';
import searchOpenedIcon from '@/assets/navBar/search-white.svg';
import notificationsIcon from '@/assets/navBar/notification.svg';
import notificationsGrayIcon from '@/assets/navBar/notification-gray.svg';
import messagesIcon from '@/assets/navBar/message.svg';
import messagesGrayIcon from '@/assets/navBar/message-gray.svg';
import cartIcon from '@/assets/navBar/cart.svg';
import cartGrayIcon from '@/assets/navBar/cart-gray.svg';
import favoritesIcon from '@/assets/navBar/favo.svg';
import favoritesGrayIcon from '@/assets/navBar/favo-gray.svg';
import rightMark from '@/assets/icons/rightMark.svg';
import languageIcon from '@/assets/icons/language.svg';
import verifyIcon from '@/assets/icons/verified.svg';
import ActivityLog from '@/assets/icons/activity.svg';
import WinWithCezma from '@/assets/icons/win_with_cezma.svg';
import websiteSettingsIcon from '@/assets/icons/setting.svg';
import websiteSettingsIconGray from '@/assets/icons/setting_gray.svg';
import { mapState } from 'pinia';
import Modal from "@/components/generic/Modal.vue";

export default {
  name: 'MainHeader',
  components: {
    MainHeaderSearch,
    IconMyStores,
    SidebarMainCategoryItem,
    SidebarSubCategoryItem,
    Modal
  },
  setup() {
    const global = useGlobalStore();
    const usedCookieLanguage = useCookie('localStorageCopy')?.value?.language || 'ar';
    const userLocalCopy = global?.localStorageCopy?.user || usedCookieLanguage?.user;
    return {
      global,
      router: useRouter(),
      route: useRoute(),
      usedCookieLanguage
    };
  },
  data() {
    return {
      showNestedMenu: false,
      APIREQUESTS,
      MAINROLES,
      ROUTESNAMES,
      menuClosedIcon,
      menuOpenedIcon,
      searchClosedIcon,
      searchOpenedIcon,
      IconApp,
      cartIcon,
      showSwitchAccountModal: false,
      rightMark,
      verifyIcon,
      languageIcon,
      websiteSettingsIcon,
      websiteSettingsIconGray,
      ActivityLog,
      WinWithCezma,

      unreadNotificationsCount: 0,
      lang: '',
      showMenu: false,
      showSearch: false,
      showLanguage: false,
      showControlPanelDropdown: false,
      tabletScreenBreakpoint: 1024,
      mediaQuery: null,
      currentSidebarViewIndex: 0,
      activeCategoryItem: [],
      dialog: {
        isOpen: false,
        type: '',
      },
      showProfile: false,
      showSettings: false,
      showWizardForAllPages: false,
      accounts: [],
      currentAccountId: 1,
      showAddAccountModal: false,
      showAddAccountPass: false,
      isAddAccountProcessing: false,
      formData: {
        phone_or_email: '',
        password: ''
      },
      deleteAccountDialog: {
        isOpen: false,
        userIdToDelete: null
      },
    };
  },
  computed: {
    ...mapState(useGlobalStore, ["isUserLogged", "getLocalStorageCopy"]),
    isResellerOnly() {
      return this.userInfo?.role?.toLowerCase() === SPECIFICROLES.reseller;
    },
    isModeratorReseller() {
      return this.userInfo?.role?.toLowerCase() === SPECIFICROLES.moderator_reseller;
    },
    notModeratorReseller() {
      return this.userInfo?.role?.toLowerCase() !== SPECIFICROLES.moderator_reseller;
    },
    userInfo() {
      const userLocalCopy = this.getLocalStorageCopy?.user || this.usedCookieLanguage?.user;
      return userLocalCopy;
    },
    finalizedNameKey() {
      return this.nameKey || `name_${this.usedCookieLanguage}`;
    },
    categories() {
      return this.global.getCategories || [];
    },
    hideChatLink() {
      return !!this.global?.disableChatting
    },
    currentPage() {
      return this.$route.fullPath
    },
    pageLinks() {
      return [
        { icon: notificationsIcon, iconGray: notificationsGrayIcon, name: this.$t('user.header.notifications'), route: ROUTESNAMES.user.notifications },
        ...(!this.hideChatLink ? [{ icon: messagesIcon, iconGray: messagesGrayIcon, name: this.$t('user.header.chat'), route: ROUTESNAMES.user.chats }] : []),
        { icon: cartIcon, iconGray: cartGrayIcon, name: this.$t('user.header.cart'), route: ROUTESNAMES.user.cart },
        { icon: favoritesIcon, iconGray: favoritesGrayIcon, name: this.$t('user.header.favourite'), route: ROUTESNAMES.user.favourite },
      ];
    },
    isReseller() {
      return this.userInfo?.role?.toLowerCase() == SPECIFICROLES.reseller || this.userInfo?.role?.toLowerCase() == SPECIFICROLES.moderator_reseller;
    },
    isGuest() {
      return this.userInfo?.role?.toLowerCase() == SPECIFICROLES.guest
    },
    currentCartCount() {
      return this.isUserLogged ? parseInt(localStorage.getItem('cart_items_count') || 0) : 0
    },
    canAccessWalletPage() {
      const currentRole = this.userInfo?.role?.toLowerCase();
      return currentRole === 'reseller' || currentRole === 'moderator_reseller' || currentRole === 'user';
    },
  },
  methods: {
    hovering() {
      const profileLi = document.querySelector('li[title="' + this.$t('user.header.profile') + '"]');
      if (profileLi) {
        profileLi.addEventListener('mouseenter', () => {
          this.showNestedMenu = true;
        });
        profileLi.addEventListener('mouseleave', () => {
          this.showNestedMenu = false;
        });
      }
    },
    getFavorites() {
      return new Promise((resolve, reject) => {
        this.makeRequest({
          owner: this.MAINROLES.user,
          url: this.APIREQUESTS.user.getFavoriteIDs.url,
          method: this.APIREQUESTS.user.getFavoriteIDs.method,
        })
          .then((res) => {
            //check response
            if (!res.status) {
              //not ok
              reject();
              this.notify({ type: 'error', msg: res?.message || this.$t('general.failed') });
            } else {
              //ok
              resolve();
              // save the favorites in the localStorage
              this.useLocalStorage({ type: 'set', key: 'favoriteProducts', value: res.data || [] });
            }
          })
          .catch((err) => {
            reject();
            this.notify({ type: 'error', msg: err?.data?.message });
          });
      });
    },
    async switchAccount(newAccountId) {
      // set a new token for the new account
      this.useLocalStorage({
        type: "set", key: "user", value: {
          ...this.useLocalStorage({ type: "get", key: "user" }),
          token: this.accounts.find(account => account.id === newAccountId)?.cezmaAuthToken
        }
      });
      let firebaseToken = '';
      try {
        firebaseToken = await getFirebaseToken();
      } catch (err) {
        console.log('error getting firebase token', err);
      }
      let payload = {
        uid: useCookie('UID', {
          'secure': true
        })?.value,

        firebase_token: firebaseToken
      }
      this.makeRequest({
        owner: MAINROLES.user,
        method: APIREQUESTS.general.refreshToken.method,
        url: APIREQUESTS.general.refreshToken.url,
        formData: JSON.stringify(payload),
        includeUID: true,
      })
        .then((res) => {
          this.isLoading = false;
          // failed
          if (!res?.status) {
            this.notify({
              type: 'error',
              msg: res.message,
            });
          } else {
            const role = res.data.role;
            // succeeded
            let user = this.useLocalStorage({ type: "get", key: "user" }) || {};
            let admin = this.useLocalStorage({ type: "get", key: "admin" }) || {};
            let new_token = res.data.access_token;
            if (role == 'moderator_reseller') {
              const new_user = res.data;
              const user_after_update = { ...new_user, token: new_token, permissions: res.data.permissions };
              this.useLocalStorage({ type: "set", key: "user", value: user_after_update });
              window.location.reload();
            } else {
              const new_user = res.data;
              const user_after_update = { ...new_user, token: new_token, permissions: res.data.permissions };
              this.useLocalStorage({ type: "set", key: "user", value: user_after_update });
              window.location.reload();
            }

          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.notify({
            type: 'error',
            msg: err?.data?.message || err,
          });
        });
    },
    toggleSwitchAccountModal() {
      this.showSwitchAccountModal = !this.showSwitchAccountModal;
      if (this.showSwitchAccountModal) {
        this.fetchAccounts(); // Fetch accounts when opening modal
      }
    },
    onSwitchAccountClick() {
      this.toggleSwitchAccountModal();
      this.showProfile = false;
      this.showMenu = false;
    },
    hasPermissionsExceptGet(section) {
      if (!section || typeof section !== 'string') return false;
      const permissions = this.getLocalStorageCopy?.user?.permissions?.[section] || {};
      return Object.entries(permissions)
        .some(([key, value]) => key !== 'get' && value === 1);
    },
    navigateToSearchPage() {
      if (this.$route.path != '/search') {
        this.$router.push('/search')
      }
    },
    toggleShowWizardForAllPages() {
      this.showWizardForAllPages = !this.showWizardForAllPages
      let skipTypeLocale = this.useLocalStorage({ type: 'get', key: 'skipType' }) || {};
      skipTypeLocale = {
        ...skipTypeLocale,
        isSkipAll: !this.showWizardForAllPages,
      };
      this.useLocalStorage({ type: 'set', key: 'skipType', value: skipTypeLocale });
    },
    getCurrentQueryObj() {
      try {
        let encodedQuery = this.route.fullPath.split('?')[1];
        let decodeQuery = decodeURIComponent(atob(encodedQuery));
        let queryObj = parseQueryString(decodeQuery);
        return queryObj;
      } catch {
        return {};
      }
    },
    changeCurrentSidebarViewIndex(newValue) {
      if (typeof newValue == 'number') {
        this.currentSidebarViewIndex = newValue;
      }
    },
    updateUnreadMessages(newState = 0) {
      let userLocal = this.useLocalStorage({ type: 'get', key: 'user' }) || {}
      this.useLocalStorage({
        type: 'set', key: 'user', value: {
          ...userLocal,
          unread_messages: newState
        }
      })
    },
    handleChangeLanguage(lang) {
      //first switch lang in state
      //second change language in local storage depend on lang value
      useLocalStorage({ type: 'set', key: 'language', value: lang });
      this.closeDialog()
      //third call api change language
      const isUserExist = Object.keys(useLocalStorage({ type: 'get', key: 'user' })).length;
      isUserExist &&
        this.makeRequest({
          owner: MAINROLES.user,
          url: APIREQUESTS.general.changeLanguage.url,
          method: APIREQUESTS.general.changeLanguage.method,
          formData: JSON.stringify({ language: lang }),
        })
          .then((res) => {
            //check response
            if (!res?.status) {
              //not ok
              this.notify({ type: 'error', msg: res?.message });
            } else {
              //ok
            }
          })
          .catch((err) => {
            this.notify({ type: 'error', msg: err?.data?.message });
          });

    },
    onMainCategoryItemClick({ item, link }) {
      if (item?.children?.length > 0) {
        this.activeCategoryItem = item;
        this.currentSidebarViewIndex = 2;
      } else if (link) {
        this.router.push(link);
        this.showMenu = false;
      }
    },
    onSubCategoryItemClick({ link }) {
      if (link) {
        this.router.push(link);
        this.showMenu = false;
      }
    },
    handleLogout() {
      //close dialog
      this.closeDialog();
      this.showSwitchAccountModal = false
      // send api of logout
      const cookieUID = useCookie('UID', {
        secure: true,
      })?.value;

      const bodyRequest = {
        uid: cookieUID,
      }
      this.makeRequest({
        owner: MAINROLES.user,
        url: APIREQUESTS.user.logout.url,
        method: APIREQUESTS.user.logout.method,
        formData: JSON.stringify(bodyRequest),
      })
        .then((res) => {
          //check response
          if (!res?.status) {
            //not ok
            this.notify({ type: 'error', msg: res?.message });
          } else {
            //ok
            //clear user object on local storage
            useLocalStorage({ type: 'set', key: 'user', value: {} });
            useLocalStorage({ type: 'set', key: 'favoriteProducts', value: [] });
            this.global?.updateStoresData({}, true);
            localStorage.removeItem('cart_items_count');
            //close dialog
            this.closeDialog();
            //goto login page
            this.router.push(ROUTESNAMES.user.login);
          }
        })
        .catch((err) => {
          this.notify({ type: 'error', msg: err?.data?.message });
        });
      useLocalStorage({ type: 'set', key: 'user', value: {} });
      //close dialog
    },
    openDialog(dialogType) {
      //reset uset changes without saving it in local sotrage by  clicking on confirm button
      this.lang = useLocalStorage({ type: 'get', key: 'language' }) || 'ar'
      this.dialog = {
        isOpen: true,
        type: dialogType
      }
      if (dialogType === 'confirmation') {
        this.$nextTick(() => {
          // focus on the close button once the popup appears
          this.$refs.closeLoggingoutConfirmationBtn?.focus();
        })

      }
    },
    closeDialog() {
      this.dialog = {
        isOpen: false,
        type: ''
      }
    },
    getUnreadNotificationsCount() {
      if (!this.isUserLogged) return;
      this.makeRequest({
        owner: MAINROLES.user,
        url: APIREQUESTS.user.getUnreadCount.url,
        method: APIREQUESTS.user.getUnreadCount.method,
      })
        .then((res) => {
          //check response
          if (!res?.status) {
            //not ok
            // this.notify({type: "error",msg: res?.message})
          } else {
            //ok
            this.unreadNotificationsCount = res?.data?.notifications_count || 0;
            this.updateUnreadMessages(res?.data?.messages_count || 0);
            this.global.setNotificationsCount(this.unreadNotificationsCount);
          }
        })
        .catch((err) => { });
    },
    onMagnifierClick() {
      this.navigateToSearchPage()
      this.showSearch = !this.showSearch;
      this.showMenu = false;
      const headerSearchRef = this.$refs['headerSearchRef'];
      headerSearchRef?.autoInputFocus();
    },
    toggleSidebar() {
      this.showMenu = !this.showMenu;
      this.showSearch = false;
      if (this.showMenu) {
        this.$nextTick(() => {
          this.$refs.sidebarMenu?.querySelector('button')?.focus();
        })
      }
    },
    handleUnreadNotificationsCount() {
      this.unreadNotificationsCount = 0;
      this.global.setNotificationsCount(this.unreadNotificationsCount);
    },
    updateMobileViewState(e) {
      if (e?.matches) {
        // in the desktop view
        document.body.style.overflowY = 'visible';
      } else {
        // in the tablet view
        document.body.style.overflowY = 'hidden';
      }
    },
    async refreshFirebaseToken() {
      if (!this.isUserLogged) return;

      // first get current firebase token
      let firebaseToken = '';
      try {
        firebaseToken = await getFirebaseToken();
      } catch (err) { }
      if (!firebaseToken) return;
      // then send firebase token
      this.makeRequest({
        owner: MAINROLES.user,
        url: APIREQUESTS.general.refreshFirebase.url,
        method: APIREQUESTS.general.refreshFirebase.method,
        formData: JSON.stringify({ firebase_token: firebaseToken }),
        includeUID: true,
      })
        .then((res) => {
          if (!res?.status) {
            //not ok
          } else {
            //ok
          }
        })
        .catch((err) => { });
    },
    async fetchAccounts() {
      try {
        const cookieUID = useCookie('UID')?.value;
        const response = await this.makeRequest({
          owner: MAINROLES.user,
          url: `${APIREQUESTS.user.getAccounts.url}/${cookieUID}`,
          method: APIREQUESTS.user.getAccounts.method
        });

        if (response?.message == 'Response Successfully') {
          this.accounts = response.data;
          this.accounts = this.accounts.map(account => ({
            id: account.cezma_id,
            name: account.fullname,
            email: account.email,
            photoUrl: account.photoUrl,
            isOnline: account.isOnline,
            lastActive: account.lastActive,
            storeIDs: account.storeIDs,
            cezmaAuthToken: account.cezmaAuthToken,
            userID: account.userId
          }));
          this.currentAccountId = this.accounts.find(account => account.id == this.userInfo?.id)?.id;
          // sort the account by the current account id
          this.accounts = this.accounts.sort((a, b) => a.id === this.currentAccountId ? -1 : b.id === this.currentAccountId ? 1 : 0);
          // this.accounts = [
          //   {
          //     id: 1,
          //     name: 'Account 1',
          //     email: 'account1@example.com',
          //   },
          //   {
          //     id: 2,
          //     name: 'Account 2',
          //     email: 'account2@example.com',
          //   },
          // ]
        } else {
          this.notify({ type: 'error', msg: response?.message });
        }
      } catch (error) {
        this.notify({ type: 'error', msg: error?.data?.message ? error?.data?.message : 'Something went wrong' });
      }
    },
    async deleteAccount(accountId) {
      try {
        const cookieUID = useCookie('UID')?.value;
        const response = await this.makeRequest({
          owner: MAINROLES.user,
          url: `${APIREQUESTS.user.deleteAccount.url}/${accountId}/${cookieUID}`,
          method: APIREQUESTS.user.deleteAccount.method,
        });

        if (response?.message == 'Response Successfully') {
          this.notify({ type: 'success', msg: this.$t('general.account_deleted_successfully') });
          await this.fetchAccounts();
        } else {
          this.notify({ type: 'error', msg: response?.message });
        }
      } catch (error) {
        this.notify({ type: 'error', msg: error?.data?.message });
      }
    },
    toggleAddAccountModal() {
      this.showAddAccountModal = !this.showAddAccountModal;
    },
    async submitForm() {
      this.isProcessing = true;
      //second--- store data in body request  and firebase
      let firebaseToken = null;
      try {
        firebaseToken = await getFirebaseToken();
      } catch {
        firebaseToken = null;
      }
      const cookieUID = useCookie('UID', {
        secure: true,
      })?.value;
      const bodyRequest = {
        phone_or_email: this.formData.phone_or_email.trim(),
        password: this.formData.password,
        type: 'user',
        uid: cookieUID,
        ...(firebaseToken && { firebase_token: firebaseToken }),
      };

      //third--- make request
      this.makeRequest({
        url: this.APIREQUESTS.user.login.url,
        method: this.APIREQUESTS.user.login.method,
        formData: JSON.stringify(bodyRequest),
      })
        .then((res) => {
          if (!res?.status) {
            this.isProcessing = false;
            this.notify({ type: 'error', msg: res?.message });
            if (res?.error_code == 1001) {
              this.useLocalStorage({
                type: 'set',
                key: 'tempTokens',
                value: {
                  phone: res?.data?.otp_token,
                  email: null,
                },
              });
              this.router.push('/otp?by=phone&page=login');
            }
            return;
          }
          //store token in local storage
          const user = {
            ...res?.data?.user,
            token: res?.data?.access_token,
            ...(res?.data?.permissions && { permissions: res?.data?.permissions }),
          };
          this.useLocalStorage({ type: 'set', key: 'user', value: user });
          // removes savedStoresData
          this.updateStoresData({}, true);
          // get the favorite products, then direct user to the homepage
          this.getFavorites().finally(() => {
            this.isProcessing = false;
            let upgradeRedirectCondition = (user?.role == SPECIFICROLES.reseller || user?.role == SPECIFICROLES.moderator_reseller) && this.route?.query?.destination == 'upgrade';

            if (upgradeRedirectCondition) {
              this.handelControlPanel({ redirectToPanelPage: 'stores' });
            } else {
              const lastVisitedRoute = this.router?.options?.history?.state?.back || '';
              if (
                lastVisitedRoute &&
                !lastVisitedRoute?.includes(`/${ROUTESNAMES.user.login}`) &&
                !lastVisitedRoute?.includes(`/${ROUTE_ROLES.reseller}`) &&
                !lastVisitedRoute?.includes(`/${ROUTE_ROLES.moderator_reseller}`)
              ) {
                this.router.replace(lastVisitedRoute);
              } else {
                this.router.replace('/');
              }
            }
          });
        })
        .catch((err) => {
          this.isProcessing = false;
          this.notify({ type: 'error', msg: err?.data?.message });
        }).finally(() => {
          this.isProcessing = false;
          this.showAddAccountModal = false;
          this.$router.go(0);
        });
    },
    confirmDeleteAccount(userId) {
      this.deleteAccountDialog.userIdToDelete = userId;
      this.deleteAccountDialog.isOpen = true;
    },

    closeDeleteAccountDialog() {
      this.deleteAccountDialog.isOpen = false;
      this.deleteAccountDialog.userIdToDelete = null;
    },

    proceedWithAccountDeletion() {
      if (this.deleteAccountDialog.userIdToDelete) {
        this.deleteAccount(this.deleteAccountDialog.userIdToDelete);
        this.closeDeleteAccountDialog();
      }
    },
  },
  watch: {
    hovering(val) {
      this.showNestedMenu = val;
    },
    userInfo(userInfo) {
      this.global.setUserInfo(userInfo);
    },
    isUserLogged: {
      immediate: true,
      handler(isUserLogged) {
        if (isUserLogged) {
          this.getUnreadNotificationsCount();
        } else {
          this.unreadNotificationsCount = 0;
        }
      }
    },
    showMenu(val) {
      if (typeof val === 'boolean' && process.client) {
        // remove the scrollbar when the sidebar window is opened to prevent the user from scrolling the elements behind
        if (val) {
          // Note: the matchMedia might not work with all browsers but it's better than using the resize event anyway
          this.mediaQuery = window.matchMedia(`(min-width: ${this.tabletScreenBreakpoint}px)`);
          this.updateMobileViewState(this.mediaQuery);
          this.mediaQuery?.addListener(this.updateMobileViewState);

          // hide the Tawk chat
          this.changeTawkVisibility(false);
        } else {
          this.showProfile = false;
          this.showSettings = false;
          this.showControlPanelDropdown = false;
          // show the Tawk chat
          this.changeTawkVisibility(true);
          document.body.style.overflowY = 'visible';
          this.mediaQuery?.removeListener(this.updateMobileViewState);
          // reset data when the sidebar window is closed
          this.currentSidebarViewIndex = 0;
        }
      }
    },
  },
  created() {
    if (process.client) {
      // check language in local storage
      this.$nextTick(() => {
        let languageInlocal = useLocalStorage({ type: 'get', key: 'language' });
        this.lang = languageInlocal;
      });
    }
  },

  async mounted() {
    if (process.client) {
      // Initialize mediaQuery here
      this.mediaQuery = window.matchMedia(`(max-width:1024px)`);

      // Add popstate handler
      window.onpopstate = (event) => {
        if (this.showMenu) {
          history.pushState(null, document.title, location.href);
          this.showMenu = false;
        }
      };

      // Add beforeunload handler  
      window.onbeforeunload = (event) => {
        if (this.showMenu) {
          event.preventDefault();
          this.showMenu = false;
        }
      };

      // Check language in localStorage
      let languageInlocal = useLocalStorage({ type: 'get', key: 'language' });
      this.lang = languageInlocal;

      // Handle FCM and push notifications
      this.refreshFirebaseToken();

      firebaseMessage?.addListener((payload) => {
        this.getUnreadNotificationsCount();
        payload?.data?.type === 'chat_message' && this.updateUnreadMessages(1);
        this.notify({
          time: 5000,
          type: 'notification',
          msg: `
            ${payload?.notification?.title}<br>
            ${payload?.notification?.body}
            `,
          handleClick: () => this.handleNotificationActions(payload?.data?.type, payload?.data?.type_id),
        });
      });

      // Set wizard state
      this.showWizardForAllPages = !this.useLocalStorage({ type: 'get', key: 'skipType' })?.isSkipAll;

      // Disable beforeunload alert
      window.onbeforeunload = null;
    }
  },
  beforeUnmount() {
    if (process.client) {
      this.mediaQuery?.removeListener(this.updateMobileViewState);
    }
    document.body.style.overflowY = 'visible';
  },
};
</script>

<style scoped>
.sidebar__container {
  max-height: 100vh;
  max-height: 100svh;
  max-height: 100dvh;
}

a.router-link-exact-active {
  background-color: #999a9b3f;
  padding-left: 1rem
    /* 16px */
  ;
  padding-right: 1rem
    /* 16px */
  ;
}

@media (min-width: 1024px) {

  /*
    span:hover{
      padding-left: 0px;
      padding-right: 0px;
      transform: scale(.7);
      background-color: #51515200;
      box-shadow: #00000040 0px 54px 55px, #0000001f 0px -12px 30px, #0000001f 0px 4px 6px, #0000002b 0px 12px 13px, #00000017 0px -3px 5px;
    }
    */
  a:hover {
    padding-left: 0px;
    padding-right: 0px;
    background-color: #51515200;
    box-shadow: #00000040 0px 54px 55px, #0000001f 0px -12px 30px, #0000001f 0px 4px 6px, #0000002b 0px 12px 13px, #00000017 0px -3px 5px;
  }

  a.router-link-exact-active {
    padding-left: 0px;
    padding-right: 0px;
    transform: scale(0.8);
    background-color: #51515200;
    box-shadow: #00000040 0px 54px 55px, #0000001f 0px -12px 30px, #0000001f 0px 4px 6px, #0000002b 0px 12px 13px, #00000017 0px -3px 5px;
  }

  #not-logged a:hover {
    padding-left: 2px;
    padding-right: 2px;
    background-color: transparent;
    box-shadow: 0px 0px 10px #3f3f3f41;
  }

  #not-logged a.router-link-exact-active {
    padding-left: 2px;
    padding-right: 2px;
    transform: scale(1);
    background-color: transparent;
    box-shadow: 0px 0px 10px #3f3f3f66;
  }
}
</style>
